const EventMessage = {
  206: '您的账号异常，请直接联系我们'
};

import { EventEmitter } from 'events';

const EventName = {
  206: '206',
  hideDropDown: 'hideDropDown' // 滚动时，select option自动隐藏
};

export { EventName, EventMessage };

export default new EventEmitter();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/eventUtils.ts